const common = {
  'common.loading': '加载中...',
  'common.nav.home': '首页',
};

export default common;
